var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['user-layout-wrapper', _vm.isMobile && 'mobile'],attrs:{"id":"userLayout"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"user-layout-content"},[_c('div',{staticClass:"top"}),_c('router-view')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }